module.exports = __webpack_public_path__ + "static/media/BlackpastDemo-vm2l9.cc85ce96.ttf";